module.exports = __webpack_public_path__ + "430b92d5bb6d61288d56f7bf5e061ace.fbx";